import {
	PlatformDependencies,
	WorkspaceConfiguration,
} from '@citrite/workspace-ui-platform';
import URI from 'urijs';
import { container } from 'Workspace/DependencyManagement';

// https://docs.google.com/document/d/1CqG1TvxuB0FNSoAT9gi8JMKZg6ZSOcRSv5NvqvVSF3o/edit?tab=t.0
const keyTicketsInIca = 'ticketsInIca';

function shouldIncludeServiceTicketsInIca(
	workspaceConfiguration: WorkspaceConfiguration
) {
	return workspaceConfiguration?.ticketService?.supportedTickets?.ticket?.length > 0;
}

/**
 * Builds the URL parameter for service tickets in the ICA file.
 * @param workspaceConfiguration The workspace configuration object.
 * @returns The URL parameter string for service tickets in the format 'AOTTicket|AnotherTicket'.
 */
export function serviceTicketsListWithSeparator(
	workspaceConfiguration: WorkspaceConfiguration
): string {
	return workspaceConfiguration?.ticketService?.supportedTickets?.ticket?.reduce(
		(acc, ticket, index) => {
			return index === 0 ? ticket.type : `${acc}|${ticket.type}`;
		},
		''
	);
}

export function appendServiceTicketsParams(
	urlOrParamString: string,
	isUrl = true
): string {
	const workspaceConfiguration = container
		.resolve(PlatformDependencies.WorkspaceConfiguration)
		.get();

	if (!shouldIncludeServiceTicketsInIca(workspaceConfiguration)) {
		return urlOrParamString;
	}

	const serviceTicketsList = serviceTicketsListWithSeparator(workspaceConfiguration);

	if (serviceTicketsList.length === 0) {
		return urlOrParamString;
	}

	if (!isUrl) {
		return `${urlOrParamString}&${keyTicketsInIca}=${serviceTicketsList}`;
	}

	return new URI(urlOrParamString)
		.addSearch(keyTicketsInIca, serviceTicketsList)
		.toString();
}
